const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * A mensagem já existe no servidor?
 *
 * Mensagens em envio ou com falha vivem só no cliente (RAM + IndexedDB) e recebem um ID
 * provisório de `makeDummyIdMensagem()` — um timestamp, não um UUID. O backend grava
 * mensagens no Cassandra, cujo driver exige UUID: mandar o ID provisório derruba a
 * requisição com 500 ("Invalid string representation of Uuid").
 *
 * Use isto antes de qualquer chamada que envie o ID da mensagem ao backend.
 */
export function ehIdMensagemPersistida(idMensagem: string): boolean {
    return UUID_REGEX.test(idMensagem);
}
